import { styled } from '@mui/material';

export const ProgramsSectionWrap = styled('div')(() => ({
	display: 'grid',
	gap: '24px',
	gridTemplateColumns: '1fr',
}));
